import styles from './CommentView.module.css'
import commentImg from './../../../../image/ic_comment.svg'
import { useNavigate } from 'react-router-dom'
import { EmojiDomain, parseUnicode, StoryItem } from '../../../../models/commonModels';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux';
import { fetchUserReactions, getReactions, getReactionsArr } from '../../../../store/comment-slice/CommentSlice';
import { UserOutlined } from '@ant-design/icons';
import icBacl from './../../../../image/ic_back_button.png'
import icReactions from './../../../../image/ic_reactions.svg'
import { Avatar } from 'antd';
import { sendReaction } from '../../../../store/lenta-slice/LentaSlice';
import { CommentViewItem } from './CommentViewItem';
export const CommentView = (
    {
        x,
        y,
        onClose,
        startYOffser,
        commentItem,
        onCommentClick,
        commentPageVisible
    }
    :
    {
        x:number,
        y:number,
        onClose:()=>void,
        startYOffser:number,
        commentItem:StoryItem,
        onCommentClick:()=>void,
        commentPageVisible:boolean
    }) =>{
    const navigation = useNavigate();
    const dispatch:any = useAppDispatch()
    const [startY,setStartY] = useState<number|null>(null)
    const [isComment,setIsComment] = useState(false)
    const reaction:string[] = useAppSelector(state=>state.commentStore.reactions)
    const userReactions:EmojiDomain[] = useAppSelector(state=>state.commentStore.userReactions)
    useEffect(()=>{
        if(reaction.length==0)dispatch(getReactions())
        if(startY==null){
            setStartY(startYOffser)
            return
        }
        
        Math.abs(startY-startYOffser)>100&&commentPageVisible==false&&onClose()
    },[startYOffser])

    useEffect(()=>{
        if(isComment){
            dispatch(getReactionsArr(commentItem.story_id))
        }else{
            dispatch(fetchUserReactions([]))
        }
        
    },[isComment])
    
    return(
        <div className={styles.comment_view}>
            <div className={styles.comment_view_menu} style={{left:x,top:y}}>
                {isComment==true&&<div className={styles.comment_view_menu_content}>
                    <div className={styles.comment_view_menu_item} onClick={()=>setIsComment(false)}>
                        <img src={icBacl}/>
                        <div>Назад</div>
                    </div>
                    
                    {userReactions.map((item)=>{
                        return <CommentViewItem 
                                icon={"https://sportsrestaurant.online/stored/images/avatar/"+item.u_id} 
                                uname={item.user_name} 
                                emoji={item.emoji} />
                    })}
                    
                </div>}
                {isComment==false&&<div className={styles.comment_view_menu_content}>
                    <div className={styles.comment_view_reactions_container}>
                    {reaction.map((reactionItem, index)=>{
                                        return(<div style={{display:"inline-block", cursor:"pointer"}}
                                        onClick={()=>{onClose() 
                                        dispatch(sendReaction(commentItem.story_id,reaction[index]))}}>
                                            {parseUnicode(reactionItem)}
                                        </div>)
                                    })}
                    </div>
                    {commentItem.emojis.length>0&&<div className={styles.comment_view_menu_item} onClick={()=>setIsComment(true)}>
                        <img src={icReactions}/>
                        <div>{commentItem.emojis.length + " Реакции"}</div>
                    </div>}
                    <div className={styles.comment_view_menu_item} onClick={()=>{onCommentClick()}}>
                        <img src={commentImg}/>
                        <div>Комментировать</div>
                    </div>
                </div>}
                
            </div>
        </div>
    )
}

